module.exports = __webpack_public_path__ + "static/media/search.c14854b3.svg";